import { WAVEFORM_BAR_SPACING, WAVEFORM_BAR_WIDTH } from './constants';
import { range } from './math';

interface BarWaveformOptions {
  barSpacing?: number;
  barWidth?: number;
  color: string;
}

export function renderBarWaveform(
  context: CanvasRenderingContext2D,
  data: Uint8Array,
  {
    barSpacing = WAVEFORM_BAR_SPACING,
    barWidth = WAVEFORM_BAR_WIDTH,
    color,
  }: BarWaveformOptions,
) {
  if (!context || !data) return;

  const canvasHeight = context.canvas.height;
  const canvasWidth = context.canvas.width;

  const calculateBarHeight = (val: number) =>
    range(0, 255, 0, canvasHeight, val);

  context.clearRect(0, 0, canvasWidth, canvasHeight);
  context.fillStyle = color;
  data.forEach((val, i) => {
    const barX = i * (barWidth + barSpacing);
    const barHeight = calculateBarHeight(val);
    const barY = (canvasHeight - barHeight) / 2;

    context.fillRect(barX, barY, barWidth, barHeight);
  });
}
